{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-120100",
  "definition": "[120100] Disclosure - Statement by directors",
  "sheetId": "StatementByDirectors",
  "label": "Statement by Directors",
  "controls": [
    {
      "qname": "ssmt:DisclosureOfStatementByDirectorsExplanatory",
      "label": "Disclosure of Statement by Directors",
      "type": "TextBlock",
      "ui": { "control": "richtext", "rows": 10 },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOfDirectorsOpinionThatFinancialStatementsOrConsolidatedFinancialStatementsAreDrawnInAccordanceWithAccountingStandards",
      "label": "Disclosure of directors opinion that the financial statements or consolidated financial statements are drawn up in accordance with approved accounting standards and reflect true and give true and fair view of financial position and performance of the company and the group",
      "type": "YesNoItemType",
      "ui": { "control": "select", "enumSource": "type:YesNoItemType" },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:NumberOfDirectorsSigningStatementByDirectors",
      "label": "Number of directors signing Statement by Directors",
      "type": "TypeOfNumberOfDirectorsSigningStatementByDirectors",
      "ui": { "control": "select", "enumSource": "type:TypeOfNumberOfDirectorsSigningStatementByDirectors" },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] },
      "uiDefault": "2"
    },
    {
      "qname": "ssmt:NameOfFirstDirectorWhoSignedStatementByDirectors",
      "label": "Name of first director who signed Statement by Directors",
      "type": "String",
      "ui": { "control": "text", "directorNumber": 1, "maxLength": 255 },
      "required": true,
      "validators": [{ "name": "required" }, { "name": "maxLength", "value": 255 }],
      "error": {
        "required": "This is a mandatory field.",
        "maxlength": "Name must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureWhetherFirstDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfCompany",
      "label": "Disclosure whether the first director is also primarily responsible for financial management of the company",
      "type": "WhetherDirectorIsAlsoResponsibleForFinancialManagementOfCompany",
      "ui": { "control": "select", "enumSource": "type:WhetherDirectorIsAlsoResponsibleForFinancialManagementOfCompany", "directorNumber": 1 },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:TypeOfIdentificationOfFirstDirectorWhoSignedStatementByDirectors",
      "label": "Type of identification of first director who signed Statement by Directors",
      "type": "TypeOfIdentification",
      "ui": { "control": "select", "enumSource": "type:TypeOfIdentification", "directorNumber": 1 },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:IdentificationNumberOfFirstDirectorWhoSignedStatementByDirectors",
      "label": "Identification number of first director who signed Statement by Directors",
      "type": "String",
      "ui": { "control": "text", "directorNumber": 1, "maxLength": 255 },
      "required": true,
      "validators": [
        { "name": "required" },
        {
          "name": "pattern",
          "pattern": "^[0-9]{12}$",
          "message": "Please input a 12 digit Identification number.",
          "conditionalOn": {
            "qname": "ssmt:TypeOfIdentificationOfFirstDirectorWhoSignedStatementByDirectors",
            "values": ["MyKad", "MyPR", "MyKAS"]
          }
        },
        { "name": "maxLength", "value": 255 }
      ],
      "error": {
        "required": "This is a mandatory field.",
        "pattern": "Please input a 12 digit Identification number.",
        "maxlength": "Identification number must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:NameOfSecondDirectorWhoSignedStatementByDirectors",
      "label": "Name of second director who signed Statement by Directors",
      "type": "String",
      "ui": { "control": "text", "directorNumber": 2, "maxLength": 255 },
      "required": true,
      "validators": [{ "name": "required" }, { "name": "maxLength", "value": 255 }],
      "error": {
        "required": "This is a mandatory field.",
        "maxlength": "Name must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureWhetherSecondDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfCompany",
      "label": "Disclosure whether the second director is also primarily responsible for financial management of the company",
      "type": "WhetherDirectorIsAlsoResponsibleForFinancialManagementOfCompany",
      "ui": { "control": "select", "enumSource": "type:WhetherDirectorIsAlsoResponsibleForFinancialManagementOfCompany", "directorNumber": 2 },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:TypeOfIdentificationNumberOfSecondDirectorWhoSignedStatementByDirectors",
      "label": "Type of identification of second director who signed Statement by Directors",
      "type": "TypeOfIdentification",
      "ui": { "control": "select", "enumSource": "type:TypeOfIdentification", "directorNumber": 2 },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:IdentificationNumberOfSecondDirectorWhoSignedStatementByDirectors",
      "label": "Identification number of second director who signed Statement by Directors",
      "type": "String",
      "ui": { "control": "text", "directorNumber": 2, "maxLength": 255 },
      "required": true,
      "validators": [
        { "name": "required" },
        {
          "name": "pattern",
          "pattern": "^[0-9]{12}$",
          "message": "Please input a 12 digit Identification number.",
          "conditionalOn": {
            "qname": "ssmt:TypeOfIdentificationNumberOfSecondDirectorWhoSignedStatementByDirectors",
            "values": ["MyKad", "MyPR", "MyKAS"]
          }
        },
        { "name": "maxLength", "value": 255 }
      ],
      "error": {
        "required": "This is a mandatory field.",
        "pattern": "Please input a 12 digit Identification number.",
        "maxlength": "Identification number must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:NameOfThirdDirectorWhoSignedStatementByDirectors",
      "label": "Name of third director who signed Statement by Directors",
      "type": "String",
      "ui": { "control": "text", "directorNumber": 3, "maxLength": 255 },
      "required": true,
      "validators": [{ "name": "required" }, { "name": "maxLength", "value": 255 }],
      "error": {
        "required": "This is a mandatory field.",
        "maxlength": "Name must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureWhetherThirdDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfTheCompany",
      "label": "Disclosure whether the third director is also primarily responsible for financial management of the company",
      "type": "WhetherDirectorIsAlsoResponsibleForFinancialManagementOfCompany",
      "ui": { "control": "select", "enumSource": "type:WhetherDirectorIsAlsoResponsibleForFinancialManagementOfCompany", "directorNumber": 3 },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:TypeOfIdentificationOfThirdDirectorWhoSignedStatementByDirectors",
      "label": "Type of identification of third director who signed Statement by Directors",
      "type": "TypeOfIdentification",
      "ui": { "control": "select", "enumSource": "type:TypeOfIdentification", "directorNumber": 3 },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:IdentificationNumberOfThirdDirectorWhoSignedStatementByDirectors",
      "label": "Identification number of third director who signed Statement By Directors",
      "type": "String",
      "ui": { "control": "text", "directorNumber": 3, "maxLength": 255 },
      "required": true,
      "validators": [
        { "name": "required" },
        {
          "name": "pattern",
          "pattern": "^[0-9]{12}$",
          "message": "Please input a 12 digit Identification number.",
          "conditionalOn": {
            "qname": "ssmt:TypeOfIdentificationOfThirdDirectorWhoSignedStatementByDirectors",
            "values": ["MyKad", "MyPR", "MyKAS"]
          }
        },
        { "name": "maxLength", "value": 255 }
      ],
      "error": {
        "required": "This is a mandatory field.",
        "pattern": "Please input a 12 digit Identification number.",
        "maxlength": "Identification number must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:NameOfFourthDirectorWhoSignedStatementByDirectors",
      "label": "Name of fourth director who signed Statement by Directors",
      "type": "String",
      "ui": { "control": "text", "directorNumber": 4, "maxLength": 255 },
      "required": true,
      "validators": [{ "name": "required" }, { "name": "maxLength", "value": 255 }],
      "error": {
        "required": "This is a mandatory field.",
        "maxlength": "Name must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureWhetherFourthDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfCompany",
      "label": "Disclosure whether the fourth director is also primarily responsible for financial management of the company",
      "type": "WhetherDirectorIsAlsoResponsibleForFinancialManagementOfCompany",
      "ui": { "control": "select", "enumSource": "type:WhetherDirectorIsAlsoResponsibleForFinancialManagementOfCompany", "directorNumber": 4 },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:TypeOfIdentificationOfFourthDirectorWhoSignedStatementByDirectors",
      "label": "Type of identification of fourth director who signed Statement by Directors",
      "type": "TypeOfIdentification",
      "ui": { "control": "select", "enumSource": "type:TypeOfIdentification", "directorNumber": 4 },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:IdentificationNumberOfFourthDirectorWhoSignedStatementByDirectors",
      "label": "Identification number of fourth director who signed Statement by Directors",
      "type": "String",
      "ui": { "control": "text", "directorNumber": 4, "maxLength": 255 },
      "required": true,
      "validators": [
        { "name": "required" },
        {
          "name": "pattern",
          "pattern": "^[0-9]{12}$",
          "message": "Please input a 12 digit Identification number.",
          "conditionalOn": {
            "qname": "ssmt:TypeOfIdentificationOfFourthDirectorWhoSignedStatementByDirectors",
            "values": ["MyKad", "MyPR", "MyKAS"]
          }
        },
        { "name": "maxLength", "value": 255 }
      ],
      "error": {
        "required": "This is a mandatory field.",
        "pattern": "Please input a 12 digit Identification number.",
        "maxlength": "Identification number must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:NameOfFifthDirectorWhoSignedStatementByDirectors",
      "label": "Name of fifth director who signed Statement by Directors",
      "type": "String",
      "ui": { "control": "text", "directorNumber": 5, "maxLength": 255 },
      "required": true,
      "validators": [{ "name": "required" }, { "name": "maxLength", "value": 255 }],
      "error": {
        "required": "This is a mandatory field.",
        "maxlength": "Name must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureWhetherFifthDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfCompany",
      "label": "Disclosure whether the fifth director is also primarily responsible for financial management of the company",
      "type": "WhetherDirectorIsAlsoResponsibleForFinancialManagementOfCompany",
      "ui": { "control": "select", "enumSource": "type:WhetherDirectorIsAlsoResponsibleForFinancialManagementOfCompany", "directorNumber": 5 },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:TypeOfIdentificationOfFifthDirectorWhoSignedStatementByDirectors",
      "label": "Type of identification of fifth director who signed Statement by Directors",
      "type": "TypeOfIdentification",
      "ui": { "control": "select", "enumSource": "type:TypeOfIdentification", "directorNumber": 5 },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:IdentificationNumberOfFifthDirectorWhoSignedStatementByDirectors",
      "label": "Identification number of fifth director who signed Statement by Directors",
      "type": "String",
      "ui": { "control": "text", "directorNumber": 5, "maxLength": 255 },
      "required": true,
      "validators": [
        { "name": "required" },
        {
          "name": "pattern",
          "pattern": "^[0-9]{12}$",
          "message": "Please input a 12 digit Identification number.",
          "conditionalOn": {
            "qname": "ssmt:TypeOfIdentificationOfFifthDirectorWhoSignedStatementByDirectors",
            "values": ["MyKad", "MyPR", "MyKAS"]
          }
        },
        { "name": "maxLength", "value": 255 }
      ],
      "error": {
        "required": "This is a mandatory field.",
        "pattern": "Please input a 12 digit Identification number.",
        "maxlength": "Identification number must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:NameOfOtherPersonPrimarilyResponsibleForFinancialStatementsOfCompany",
      "label": "Name of other person primarily responsible for financial management of the company",
      "type": "String",
      "ui": { "control": "text", "maxLength": 255 },
      "required": false,
      "requiredIfAllVisibleDirectorsMatch": {
        "directorCountField": "ssmt:NumberOfDirectorsSigningStatementByDirectors",
        "directorFields": [
          "ssmt:DisclosureWhetherFirstDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfCompany",
          "ssmt:DisclosureWhetherSecondDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfCompany",
          "ssmt:DisclosureWhetherThirdDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfTheCompany",
          "ssmt:DisclosureWhetherFourthDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfCompany",
          "ssmt:DisclosureWhetherFifthDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfCompany"
        ],
        "equals": "Not primarily responsible for financial management of the company"
      },
      "requiredIfAnyOfGroupFilled": [
        "ssmt:NameOfOtherPersonPrimarilyResponsibleForFinancialStatementsOfCompany",
        "ssmt:TypeOfIdentificationOfOtherPersonPrimarilyResponsibleForFinancialStatementsOfCompany",
        "ssmt:IdentificationNumberOfOtherPersonPrimarilyResponsibleForFinancialManagementOfCompany"
      ],
      "validators": [{ "name": "maxLength", "value": 255 }],
      "error": {
        "required": "This is a mandatory field.",
        "maxlength": "Name must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:TypeOfIdentificationOfOtherPersonPrimarilyResponsibleForFinancialStatementsOfCompany",
      "label": "Type of identification of other person primarily responsible for financial management of the company",
      "type": "TypeOfIdentification",
      "ui": { "control": "select", "enumSource": "type:TypeOfIdentification" },
      "required": false,
      "requiredIfAllVisibleDirectorsMatch": {
        "directorCountField": "ssmt:NumberOfDirectorsSigningStatementByDirectors",
        "directorFields": [
          "ssmt:DisclosureWhetherFirstDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfCompany",
          "ssmt:DisclosureWhetherSecondDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfCompany",
          "ssmt:DisclosureWhetherThirdDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfTheCompany",
          "ssmt:DisclosureWhetherFourthDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfCompany",
          "ssmt:DisclosureWhetherFifthDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfCompany"
        ],
        "equals": "Not primarily responsible for financial management of the company"
      },
      "requiredIfAnyOfGroupFilled": [
        "ssmt:NameOfOtherPersonPrimarilyResponsibleForFinancialStatementsOfCompany",
        "ssmt:TypeOfIdentificationOfOtherPersonPrimarilyResponsibleForFinancialStatementsOfCompany",
        "ssmt:IdentificationNumberOfOtherPersonPrimarilyResponsibleForFinancialManagementOfCompany"
      ],
      "validators": [],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:IdentificationNumberOfOtherPersonPrimarilyResponsibleForFinancialManagementOfCompany",
      "label": "Identification number of other person primarily responsible for financial management of the company",
      "type": "String",
      "ui": { "control": "text", "maxLength": 255 },
      "required": false,
      "requiredIfAllVisibleDirectorsMatch": {
        "directorCountField": "ssmt:NumberOfDirectorsSigningStatementByDirectors",
        "directorFields": [
          "ssmt:DisclosureWhetherFirstDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfCompany",
          "ssmt:DisclosureWhetherSecondDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfCompany",
          "ssmt:DisclosureWhetherThirdDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfTheCompany",
          "ssmt:DisclosureWhetherFourthDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfCompany",
          "ssmt:DisclosureWhetherFifthDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfCompany"
        ],
        "equals": "Not primarily responsible for financial management of the company"
      },
      "requiredIfAnyOfGroupFilled": [
        "ssmt:NameOfOtherPersonPrimarilyResponsibleForFinancialStatementsOfCompany",
        "ssmt:TypeOfIdentificationOfOtherPersonPrimarilyResponsibleForFinancialStatementsOfCompany",
        "ssmt:IdentificationNumberOfOtherPersonPrimarilyResponsibleForFinancialManagementOfCompany"
      ],
      "validators": [
        {
          "name": "pattern",
          "pattern": "^[0-9]{12}$",
          "message": "Please input a 12 digit Identification number.",
          "conditionalOn": {
            "qname": "ssmt:TypeOfIdentificationOfOtherPersonPrimarilyResponsibleForFinancialStatementsOfCompany",
            "values": ["MyKad", "MyPR", "MyKAS"]
          }
        },
        { "name": "maxLength", "value": 255 }
      ],
      "error": {
        "required": "This is a mandatory field.",
        "pattern": "Please input a 12 digit Identification number.",
        "maxlength": "Identification number must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DateOfSigningStatementByDirectors",
      "label": "Date of signing statement by directors",
      "type": "Date",
      "ui": { "control": "date" },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "warnings": [
        {
          "id": "signing-date-after-approval-date",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "dateComparison",
            "message": "\"Date of signing statement by directors\" must be equal to or before \"Date of financial statements approved by Board of Directors\"",
            "comparisonOperator": "gt",
            "compareWith": {
              "sheet": "scopeOfFiling",
              "field": "ssmt:DateOfFinancialStatementsApprovedByBoardOfDirectors"
            }
          }
        },
        {
          "id": "signing-date-before-year-end",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "dateComparison",
            "message": "\"Date of signing statement by directors\" must be greater than \"Company's current financial year end date\"",
            "comparisonOperator": "lte",
            "compareWith": {
              "sheet": "filingPrerequisites",
              "field": "ssmt-dei:CompanyCurrentFinancialYearEndDate"
            }
          }
        }
      ],
      "ContextPolicy": { "periodTemplate": "I_CUR", "allowedAxes": [] }
    }
  ]
}
